import CloseIcon from "@mui/icons-material/Close";
import InsertDriveFileOutlinedIcon from "@mui/icons-material/InsertDriveFileOutlined";
import { Box, Grid, IconButton } from "@mui/material";
import Modal from "@mui/material/Modal";
import * as React from "react";
import { useMutation } from "react-query";
import { ApiResultModel } from "../../models/common.model";
import {
  NoticeItemDetail,
  ShowItemRequest,
} from "../../models/supplierNotice.model";
import { ShowItemNotice } from "../../services/supplierNotice.service";

const style = {
  position: "absolute" as "absolute",
  top: "40%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
};

export default function ModalNotice({
  openModalShowNoticeInfo,
  setSendConfirmation,
  setOpenVerifyModal,
  setOpenModalShowNoticeInfo,
  noticeKey,
}: any) {
  const [open, setOpen] = React.useState<boolean>(openModalShowNoticeInfo);
  const [detail, setDetail] = React.useState<NoticeItemDetail>();
  const handleClickOpen = () => {
    setOpen(true);
  };
  const handleClose = () => {
    setOpen(false);
    setOpenModalShowNoticeInfo(false);
    setSendConfirmation(false);
    setOpenVerifyModal(false);
  };
  React.useEffect(() => {
    setOpen(openModalShowNoticeInfo);
  }, [openModalShowNoticeInfo]);

  React.useEffect(() => {
    if (noticeKey != undefined && noticeKey != null) {
      const noticeItem: ShowItemRequest = {
        noticeKey: noticeKey!,
        isVisited: undefined,
      };
      GetSupplierNoticesMutation.mutateAsync(noticeItem);
    }
  }, [noticeKey]);
  const GetSupplierNoticesMutation = useMutation(ShowItemNotice, {
    onSuccess: (result: ApiResultModel<NoticeItemDetail>) => {
      if (result) {
        setDetail(result.data);
      }
    },
  });
  function handleOnCompletedClick() {
    setSendConfirmation(true);
    setOpen(false);
    setOpenVerifyModal(false);
  }
  return (
    <div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="keep-mounted-modal-title"
        aria-describedby="keep-mounted-modal-description"
        style={{ top: "20%" }}
      >
        <>
          <Grid>
            <Box
              sx={style}
              style={{
                borderRadius: "6px",
                width: "80%",
                border: "solid 3px #DAE0E4",
                outline: 0,
              }}
              // style={{ borderRadius: "6px", padding: "2px 40px 40px 40px", minWidth: "147vh", maxWidth: "150vh" }}
              className="textCenter "
            >
              <IconButton onClick={handleClose}>
                <CloseIcon
                  style={{
                    position: "fixed",
                    zIndex: "1",
                    left: "1vh",
                    color: "red",
                    top: "1vh",
                  }}
                />
              </IconButton>
              {detail ? (
                <Grid container width={"100%"} spacing={{ xs: 2, md: 3 }}>
                  <Grid
                    container
                    xs={12}
                    className="ActivePlansCardContainer"
                    style={{ paddingBottom: "2vh", paddingTop: "2vh" }}
                  >
                    <Grid item xs={12} md={1}>
                      <span style={{ color: "#9AAFC4" }}>
                        عنوان اطلاعیه: &nbsp;
                      </span>{" "}
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={7}
                      style={{ paddingRight: "2vh" }}
                      sx={{ textAlign: { xs: "center", md: "right" } }}
                    >
                      <b className="colorTitle">{detail!.title}</b>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={4}
                      sx={{ textAlign: { xs: "center", md: "left" } }}
                    >
                      <span
                        className={
                          detail!.noticeType == "Instant"
                            ? "DangerDefaultFont"
                            : "InformationDefaultFont"
                        }
                      >
                        {detail!.noticeTypePersian} -&nbsp;{" "}
                        <span
                          style={{
                            color: "#424242",
                            direction: "ltr",
                            display: "inline-block",
                          }}
                        >
                          {detail!.creationDatePersian}
                        </span>
                      </span>
                    </Grid>
                  </Grid>
                  <Grid container xs={12}>
                    <Grid item xs={2} md={1}></Grid>
                    <Grid
                      item
                      xs={10}
                      md={11}
                      style={{
                        textAlign: "right",
                        paddingRight: "2vh",
                        paddingTop: "2vh",
                        whiteSpace: "break-spaces",
                        // lineHeight: "40px",
                      }}
                    >
                      <span
                        dangerouslySetInnerHTML={{ __html: detail!.body }}
                      ></span>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={12}
                      style={{
                        textAlign: "left",
                        color: "#004BFE",
                        paddingBottom: "2vh",
                      }}
                    >
                      {" "}
                      {detail!.expirationDatePersian ? (
                        <span>
                          {" "}
                          &nbsp;تاریخ انقضاء:{" "}
                          <span
                            style={{
                              direction: "ltr",
                              display: "inline-block",
                            }}
                          >
                            {detail!.expirationDatePersian}
                          </span>
                          &nbsp;
                        </span>
                      ) : null}{" "}
                    </Grid>
                  </Grid>
                  {detail!.attachments ? (
                    <Grid
                      container
                      xs={12}
                      style={{
                        paddingTop: "15px",
                      }}
                    >
                      <Grid item xs={2} md={1} style={{ paddingTop: "3vh" }}>
                        <span
                          style={{
                            marginBottom: "5px",
                            color: "#9AAFC4",
                          }}
                        >
                          {" "}
                          ضمیمه شده: &nbsp;
                        </span>
                      </Grid>
                      <Grid
                        item
                        xs={10}
                        md={11}
                        style={{
                          textAlign: "right",
                          paddingRight: "2vh",
                          borderTop: "2px solid #edefef",
                        }}
                      >
                        <Grid item xs={12} style={{ paddingTop: "3vh" }}>
                          {detail.attachments?.map((item: any) => (
                            <Grid
                              xs={12}
                              sm={6}
                              className="UploadImageCmp"
                              style={{
                                textAlign: "center",
                                alignContent: "center",
                                alignSelf: "center",
                                display: "inline-grid",
                              }}
                              sx={{ maxWidth: "300px !important" }}
                            >
                              <a
                                href={item.fileUrl!}
                                target="_blank"
                                className="cursorPointer"
                              >
                                {item.fileType == "Image" ? (
                                  <img
                                    className="noticeCardImg"
                                    src={`${item.fileUrl}`}
                                    alt=""
                                  />
                                ) : (
                                  <span
                                    className="ImageIconNotice "
                                    style={{
                                      padding: "1vh",
                                      // width: "inherit !important",
                                    }}
                                  >
                                    <InsertDriveFileOutlinedIcon className="uploadImageIcon jusfityImage" />
                                  </span>
                                )}
                              </a>
                            </Grid>
                          ))}
                        </Grid>
                      </Grid>
                    </Grid>
                  ) : null}
                </Grid>
              ) : (
                ""
              )}
            </Box>
          </Grid>
        </>
      </Modal>
    </div>
  );
}
